import { render, staticRenderFns } from "./content_structure.vue?vue&type=template&id=2dce0979&scoped=true"
import script from "./content_structure.js?vue&type=script&lang=js&external"
export * from "./content_structure.js?vue&type=script&lang=js&external"
import style0 from "./content_structure.vue?vue&type=style&index=0&id=2dce0979&prod&lang=scss"
import style1 from "./content_structure.vue?vue&type=style&index=1&id=2dce0979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce0979",
  null
  
)

export default component.exports